import { render, staticRenderFns } from "./SignedNotices.vue?vue&type=template&id=6510668a&"
import script from "./SignedNotices.vue?vue&type=script&lang=js&"
export * from "./SignedNotices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports